// extracted by mini-css-extract-plugin
export default {"content":"OrderStepContent_content__TbOTa"};